export const INVOICE_STATUSES = [
    'VOID',
    'PAID',
    'OVERDUE',
    'PARTIALLY_PAID',
    'SENT_EXTERNALLY',
    'SENT',
    'UNSENT',
];
//# sourceMappingURL=invoice-status.js.map